import './my-pages.css'
import * as React from 'react'
import CustomerCard from '../../components/customer-card/customer-card'

/**
 * MyPages Component.
 * Represents a my-pages page.
 *
 * @returns {React.ReactElement} - MyPages Component.
 */
const MyPages = () => {
  return <CustomerCard />
}

export default MyPages
